import { render } from "./Paperclip.vue?vue&type=template&id=f57465e0"
import script from "./Paperclip.vue?vue&type=script&lang=js"
export * from "./Paperclip.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Paperclip.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f57465e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f57465e0', __exports__)) {
    api.reload('f57465e0', __exports__)
  }
  
  module.hot.accept("./Paperclip.vue?vue&type=template&id=f57465e0", () => {
    api.rerender('f57465e0', render)
  })

}


export default __exports__